import { useState } from "react";
import { useQuery } from "@tanstack/react-query";
import { ScrollText } from "lucide-react";
import { api } from "@/lib/api";
import { timeAgo, ACTION_LABELS } from "@/lib/constants";
import { Card } from "@/components/ui/card";
import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from "@/components/ui/select";

export const AuditTab = ({ ws }) => {
  const [actionFilter, setActionFilter] = useState("all");

  const { data: entries = [] } = useQuery({
    queryKey: ["audit", ws.id, actionFilter],
    queryFn: async () => {
      const params = actionFilter !== "all" ? { action: actionFilter } : {};
      return (await api.get(`/workspaces/${ws.id}/audit`, { params })).data;
    },
  });

  return (
    <div className="space-y-4" data-testid="settings-audit-tab">
      <div className="flex items-center justify-between">
        <p className="text-sm text-muted-foreground">Registro inmutable de acciones administrativas. Solo visible para administradores.</p>
        <Select value={actionFilter} onValueChange={setActionFilter}>
          <SelectTrigger className="w-48 shrink-0" data-testid="audit-filter-select"><SelectValue /></SelectTrigger>
          <SelectContent>
            <SelectItem value="all">Todas las acciones</SelectItem>
            {Object.entries(ACTION_LABELS).map(([k, v]) => (
              <SelectItem key={k} value={k}>{v}</SelectItem>
            ))}
          </SelectContent>
        </Select>
      </div>
      {entries.length === 0 ? (
        <Card className="p-8 text-center">
          <ScrollText className="h-6 w-6 mx-auto text-muted-foreground mb-2" />
          <p className="text-sm text-muted-foreground">Sin registros para este filtro.</p>
        </Card>
      ) : (
        <Card className="divide-y divide-border">
          {entries.map((a) => (
            <div key={a.id} className="p-4 flex items-center gap-3 text-sm" data-testid={`audit-row-${a.id}`}>
              <div className="h-2 w-2 rounded-full bg-primary shrink-0" />
              <p className="flex-1 min-w-0">
                <span className="font-semibold">{a.actor_name}</span>{" "}
                <span className="text-muted-foreground">{ACTION_LABELS[a.action] || a.action}</span>
                {a.metadata?.name ? <span className="font-medium"> "{a.metadata.name}"</span> : null}
                {a.metadata?.member_name ? <span className="font-medium"> · {a.metadata.member_name}</span> : null}
                {a.metadata?.email ? <span className="font-medium"> · {a.metadata.email}</span> : null}
                {a.metadata?.role ? <span className="text-muted-foreground"> (rol: {ws.role_labels?.[a.metadata.role] || a.metadata.role})</span> : null}
                {a.metadata?.status ? <span className="text-muted-foreground"> (estado: {a.metadata.status === "suspended" ? "suspendido" : "activo"})</span> : null}
                {a.metadata?.new_owner ? <span className="font-medium"> → {a.metadata.new_owner}</span> : null}
              </p>
              <span className="text-xs text-muted-foreground shrink-0">{timeAgo(a.created_at)}</span>
            </div>
          ))}
        </Card>
      )}
    </div>
  );
};
